import Skeleton from "./Skeleton";

export default function MenuSkeleton() {
  return (
    <div className="flex h-screen w-[280px] flex-col gap-6 bg-gray-50 px-4 py-8">
      <Skeleton size="lg" />
      <Skeleton size="xl" />
      <div className="flex min-h-0 flex-1 flex-col gap-1">
        {[...Array(11).keys()].map((i) => (
          <Skeleton
            key={i}
            size="md"
            className="bg-linear-to-b from-gray-200 to-white bg-fixed"
          />
        ))}
      </div>
      <Skeleton size="xl" />
      <div className="flex gap-3 pt-6">
        <div className="size-10 rounded-full bg-gray-200" />
        <div className="flex flex-1 flex-col gap-1">
          <Skeleton size="xs" className="w-1/3" fixed={false} />
          <Skeleton size="sm" className="w-3/4" fixed={false} />
        </div>
      </div>
    </div>
  );
}
